export const formatImageUrl = (node: { image?: string | { url: string }[] }, useCDN = true, noCache = true): string => {
  let url = '';
  if (typeof node?.image === 'string') {
    url = `${node.image}`;
  } else if (Array(node?.image)) {
    url = node.image?.[1] ? node.image[1].url : '';
  }
  if (useCDN) {
    url = url.replace('www.benzinga.com', 'cdn.benzinga.com');
  }
  if (noCache) {
    const regEx = new RegExp('/imagecache(.*)/images');
    url = url.replace(regEx, '/images');
  }
  return url;
};
